module.exports = __webpack_public_path__ + "img/card_franchise2.73424c4d.svg";